import { translate, translateFormatter } from '@/core/localization/translate';
export const {
  containerTitle,
  codeCopied,
  conditions
} = translate({
  "containerTitle": "Exclusive advantage",
  "codeCopied": "Copied",
  "conditions": "View conditions"
});
export const copyCode = translateFormatter<{
  code: string;
}>([{
  "type": 0,
  "value": "Copy "
}, {
  "type": 1,
  "value": "code"
}], undefined, undefined, "en");